/* eslint-disable */

import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import env from '../../env/env'
import useMediaQuery from '../../hooks/useMediaQuery'
import {
  GetAllMandates,
  MFTimeBasedBaskets,
  MFUserBaskets,
  MFUserSubsequentBaskets,
} from '../../store/MFBasketsStore'
import { useRecoilRefresher_UNSTABLE, useRecoilState, useRecoilValueLoadable } from 'recoil'
import { capitalizeWords, formatDate } from '../../utils/Util'
import { useModal } from '../../hooks/use-modal-store'
import { userDetailsState } from '../LoginState'

import { BankDetails } from '../../store/AccountDetailsStore'
import { AccountBalance } from '@mui/icons-material'
import { addMonth, formatIndianNumber } from '../../utils/Util'
import refresh from '../../assets/SVGS/refresh.svg'
import { Card } from '../../Components/ui/card'
import { post } from '../../http/restservice'
import { useErrorPopup } from '../../hooks/useErrorPopup'

import { messageModalState } from '../../store/Feedback'
import { useSetRecoilState } from 'recoil'
import PostHogTracker from '../../utils/PostHogTracker'
import { Tabs } from '../../Components/ui/tabs3'
import { TabsList } from '../../Components/ui/tabs3'
import { TabsTrigger } from '../../Components/ui/tabs3'
import { TabsContent } from '../../Components/ui/tabs3'
import Mandates from '../ActionCenter/Mandates'
import Plans from '../ActionCenter/Plans'
import Rebalancing from '../ActionCenter/Rebalancing'

const UserBankDetails = ({ day, flowStep }) => {
  const [src, setSrc] = useState('')
  const { contents: bankDetails } = useRecoilValueLoadable(BankDetails)

  let ifscCode = bankDetails?.ifscCode
  const extractedBranch = ifscCode?.match(/^[A-Za-z]{4}/)[0]?.toLowerCase()
  const iconSrc = `${env.BANK_LOGOS}/${extractedBranch}/symbol.svg`

  useEffect(() => {
    setSrc(iconSrc)
  }, [iconSrc])

  return (
    <>
      {flowStep === 0 ? (
        <div>
          <h3 className='mb-2 flex items-center gap-x-1 text-nowrap text-sm font-medium text-black-600'>
            Pay with just <span className='font-semibold text-primary-600'>One Tap</span>
          </h3>
          <Card className='flex cursor-pointer items-center gap-3 rounded-lg border-black-200 bg-white p-4 font-DMSans'>
            <div className='relative'>
              <div className='flex-shrink-0'>
                {src ? (
                  <div className='flex h-11 w-11 items-center justify-center rounded-lg border border-black-200 bg-white'>
                    <img
                      src={src}
                      alt='bank logos'
                      onError={() => {
                        setSrc(null)
                      }}
                      height={24}
                      width={24}
                    />
                  </div>
                ) : (
                  <div className='flex h-11 w-11 items-center justify-center rounded-lg border border-black-200 bg-white'>
                    <AccountBalance className='text-primary-600' />
                  </div>
                )}
              </div>
              <div className='absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full border border-white bg-secondary-300'>
                <img
                  src={refresh}
                  alt='bank logos'
                  onError={() => {
                    setSrc(null)
                  }}
                  height={24}
                  width={24}
                />
              </div>
            </div>
            <div className='flex-1'>
              <div className='font-IBM font-bold text-black-950'>
                Mandate{' '}
                <span className='font-DMSans text-xs font-medium text-black-500'>
                  (Takes 3 to 4 days to activate)
                </span>
              </div>
              <div className='text-sm text-black-600'>
                {' '}
                {capitalizeWords(bankDetails && bankDetails?.bankName)} A/c ending in{' '}
                <strong>
                  {bankDetails && bankDetails?.accountNo && bankDetails?.accountNo?.slice(-4)}
                </strong>
              </div>
            </div>
          </Card>
        </div>
      ) : (
        <div className=''>
          <h1 className='fabits-eyebrow'>Bank</h1>

          <div className='fabits-card mt-2 flex items-center gap-4 p-4'>
            <div className='flex-shrink-0'>
              {src ? (
                <div className='flex h-10 w-10 items-center justify-center rounded-lg border border-black-200 bg-white'>
                  <img
                    src={src}
                    alt='bank logos'
                    onError={() => {
                      setSrc(null)
                    }}
                    height={24}
                    width={24}
                  />
                </div>
              ) : (
                <div className='flex h-10 w-10 items-center justify-center rounded-lg border border-black-200 bg-white'>
                  <AccountBalance className='text-primary-600' />
                </div>
              )}
            </div>
            <div className='flex min-w-0 flex-col'>
              <span className='truncate font-IBM font-bold text-black-950'>
                {bankDetails && bankDetails?.accountHolderName}
              </span>
              <span className='text-xs text-black-600'>
                {bankDetails && bankDetails?.bankName} A/c ending in{' '}
                <strong>
                  {bankDetails && bankDetails?.accountNo && bankDetails?.accountNo?.slice(-4)}
                </strong>
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const UserActionPlan = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [userDetails, setUserDetails] = useRecoilState(userDetailsState)
  const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)
  const { state, contents: investedPlans } = useRecoilValueLoadable(MFUserBaskets)
  const subsequentPlans = useRecoilValueLoadable(MFUserSubsequentBaskets)
  const { state: mandatesState, contents: mandates } = useRecoilValueLoadable(GetAllMandates)
  const refreshMFUserBaskets = useRecoilRefresher_UNSTABLE(MFUserBaskets)
  const refreshMFUserSubsequent = useRecoilRefresher_UNSTABLE(MFUserSubsequentBaskets)
  const [adminPlans, setAdminPlans] = useState([])
  const [openPlans, setOpenPlans] = useState({})
  const [selectedPlans, setSelectedPlans] = useState([])
  const [isAllSelected, setIsAllSelected] = useState(true)
  const { onOpen } = useModal()
  const { showError } = useErrorPopup()
  const isDesktop = useMediaQuery('(min-width: 1024px)')

  // SIPs & OT
  const [flowStep, setFlowStep] = useState(0)
  const sipDates = [3, 5, 10, 15, 22, 25]
  const [sipDate, setSipDate] = useState('')
  const currentDate = new Date()
  const today = currentDate.getDate()
  const [selectedDay, setSelectedDay] = useState(5)
  const [openOTPPopup, setOpenOTPPopup] = useState(false)
  const [isVerified, setIsVerified] = useState(false)
  const [loading, setLoading] = useState(false)
  const email = userDetails?.email
  const clientCode = userDetails ? userDetails?.uid?.split('-')[0] : ''
  const setMessageModalState = useSetRecoilState(messageModalState)

  const { contents: bankDetails } = useRecoilValueLoadable(BankDetails)

  const [selectedBank, setSelectedBank] = useState(null)
  const [mandateLoading, setMandateLoading] = useState(false)

  // Support multiple bank accounts from API response
  const bankAccountsList = (() => {
    const accounts = []

    // If banks array exists, use it (new API format)
    if (Array.isArray(bankDetails?.banks) && bankDetails?.banks.length > 0) {
      bankDetails.banks.forEach((bank) => {
        accounts.push({
          accountNo: bank.accountNo,
          bankName: bank.bankName,
          ifscCode: bank.ifscCode,
          accountHolderName: bank.accountHolderName || bankDetails?.accountHolderName,
        })
      })
    }
    // Fallback to single bank account (backward compatibility)
    else if (bankDetails?.accountNo) {
      setSelectedBank(bankDetails.accountNo)

      accounts.push({
        accountNo: bankDetails.accountNo,
        bankName: bankDetails.bankName,
        ifscCode: bankDetails.ifscCode,
        accountHolderName: bankDetails.accountHolderName,
      })
    }

    return accounts
  })()

  useEffect(() => {
    if (bankAccountsList.length === 1) {
      setSelectedBank(bankDetails.accountNo)
    }
  }, [bankAccountsList, bankDetails])

  // First check higher amount
  // If amount same then latest timestamp
  const mandateResult = mandates?.data
    ?.filter(
      (mandate) => mandate?.mandateStatus === 'REQUESTED' && mandate?.mandateType === 'UNIVERSAL',
    )
    ?.reduce((best, current) => {
      if (best == null) return current
      const currentAmount = Number(current.amount)
      const bestAmount = Number(best.amount)

      // Higher amount wins
      if (currentAmount > bestAmount) {
        return current
      }

      // If amount same, latest date wins
      if (
        currentAmount === bestAmount &&
        new Date(current.createdTimeStamp) > new Date(best.createdTimeStamp)
      ) {
        return current
      }

      return best
    }, undefined)

  const [activeTab, setActiveTab] = useState(
    location?.state?.action === 'rebalancing'
      ? 'rebalancing'
      : mandateResult
        ? 'Mandates'
        : 'Investments',
  )

  useEffect(() => {
    const res = addMonth(today, selectedDay)
    setSipDate(res)
  }, [selectedDay, today])

  useEffect(() => {
    refreshMFUserBaskets()
    refreshMFUserSubsequent()
  }, [])

  useEffect(() => {
    const subsequentOneTimeOrSIP =
      (investedPlans &&
        investedPlans?.data?.length &&
        subsequentPlans?.state === 'hasValue' &&
        subsequentPlans?.contents?.data?.length > 0 &&
        subsequentPlans?.contents?.data) ||
      []

    if (state === 'hasValue' && subsequentPlans?.state === 'hasValue') {
      // Step 1: Get all the relevant admin plans
      const adminCuratedPlans =
        (investedPlans &&
          investedPlans?.data?.length &&
          investedPlans?.data?.filter(
            (plan) =>
              plan?.createdSource === 'ACTION PLAN' &&
              (plan?.sipStatus === 'PENDING' || plan?.oneTimeStatus === 'PENDING'),
          )) ||
        []

      // Step 2: Map and replace matching plans with those from subsequentOneTimeOrSIP
      const updatedPlans = subsequentOneTimeOrSIP?.map((plan) => {
        const match =
          investedPlans &&
          investedPlans?.data?.length &&
          investedPlans?.data?.find(
            (sub) => sub.customerBasketInvestmentId === plan.customerBasketInvestmentId,
          )

        if (
          plan?.orderStatus === 'ACTIVE' &&
          plan?.sipOrderInvestmentAmount &&
          plan?.sipOrderInvestmentBreakdown
        ) {
          return match
            ? {
              ...plan,
              ...match,
              sipInvestmentAmount: plan?.sipOrderInvestmentAmount,
              sipInvestmentBreakdown: plan?.sipOrderInvestmentBreakdown,
              sipStatus: 'PENDING',
              isSubsequentOneTimeOrder: true,
            }
            : { ...plan, sipStatus: 'PENDING' }
        }

        if (
          plan?.orderStatus === 'ACTIVE' &&
          !plan?.sipOrderInvestmentAmount &&
          !plan?.sipOrderInvestmentBreakdown
        ) {
          return match
            ? {
              ...plan,
              ...match,
              oneTimeInvestmentAmount: plan?.orderInvestmentAmount,
              oneTimeInvestmentBreakdown: plan?.orderInvestmentBreakdown,
              oneTimeStatus: 'PENDING',
              sipInvestmentAmount: null,
              sipInvestmentBreakdown: null,
              sipStatus: null,
              isSubsequentOneTimeOrder: true,
            }
            : { ...plan, sipStatus: 'PENDING' }
        }

        return match
          ? {
            ...plan,
            ...match,
            oneTimeInvestmentAmount: plan?.orderInvestmentAmount,
            oneTimeInvestmentBreakdown: plan?.orderInvestmentBreakdown,
            oneTimeStatus: 'PENDING',
            isSubsequentOneTimeOrder: true,
          }
          : { ...plan, oneTimeStatus: 'PENDING' }
      })

      const allPlans =
        [...adminCuratedPlans, ...updatedPlans]?.map((plan, index) => ({
          ...plan,
          basketIndex: index,
        })) || []

      console.log('allPlans', allPlans)

      setAdminPlans(allPlans)
      setSelectedPlans(allPlans)

      // Track action plan list viewed
      if (allPlans.length > 0) {
        PostHogTracker.actionPlanListViewed(allPlans.length)
      }
    }
  }, [state, investedPlans, subsequentPlans.state])

  useEffect(() => {
    if (isAllSelected && adminPlans?.length) {
      localStorage.setItem('selectedActionPlans', JSON.stringify(adminPlans))
      setSelectedPlans(adminPlans)
    } else if (!isAllSelected) {
      localStorage.removeItem('selectedActionPlans')
      setSelectedPlans([])
    }
  }, [isAllSelected])

  const handleCheckboxChange = (plan) => {
    setSelectedPlans((prev) => {
      const isAlreadySelected = prev.some((p) => p.basketIndex === plan?.basketIndex)
      let updatedPlans

      if (isAlreadySelected) {
        updatedPlans = prev.filter((p) => p.basketIndex !== plan.basketIndex)
      } else {
        updatedPlans = [...prev, plan]
      }

      // Store updated state in localStorage
      localStorage.setItem('selectedActionPlans', JSON.stringify(updatedPlans))

      // // Log updated state
      // console.log('🚀 ~ handleCheckboxChange ~ updatedPlans:', updatedPlans)

      return updatedPlans
    })
  }

  const togglePlan = (id) => {
    setOpenPlans((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const totalLumpsum = selectedPlans
    .filter((plan) => plan?.oneTimeStatus === 'PENDING')
    .reduce((sum, item) => sum + (item.oneTimeInvestmentAmount || 0), 0)

  const totalSip = selectedPlans
    .filter((plan) => plan?.sipStatus === 'PENDING')
    .reduce((sum, item) => sum + (item.sipInvestmentAmount || 0), 0)

  const generateOTP = async () => {
    setLoading(true)
    const response = await post(
      `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
      {
        phoneNumber: userDetails?.phoneNumber,
        email: email.includes('fabits') ? '' : email,
      },
    )

    if (response.isError) {
      PostHogTracker.buttonClicked('Order OTP Resend Failed', {
        page_name: 'Action Center Orders Page',
      })

      showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => { })
    }

    if (!response.isError) {
      PostHogTracker.buttonClicked('Order OTP Resend Successful', {
        page_name: 'Action Center Orders Page',
      })

      setOpenOTPPopup(true)
    }
  }

  const handleSipOrOT = () => {
    flowStep === 0 ? handleXSips() : placeOneTimeOrder()
  }

  const sipPlans = selectedPlans
    ?.filter((plan) => Number(plan.sipInvestmentAmount) > 0 && plan.sipStatus === 'PENDING')
    ?.filter((fund) => fund?.weightage != 0)

  const oneTimePlans = selectedPlans
    ?.filter((plan) => Number(plan.oneTimeInvestmentAmount) > 0 && plan.oneTimeStatus === 'PENDING')
    ?.filter((fund) => fund?.weightage != 0)

  const calculateParcentageAmount = (parcentage, totalAmount) => {
    const result = totalAmount * (parcentage / 100)
    return Math.ceil(result)
  }

  useEffect(() => {
    if (sipPlans.length) {
      setFlowStep(0)
      return
    }

    if (oneTimePlans.length) {
      setFlowStep(1)
      return
    }
  }, [sipPlans, oneTimePlans])

  const handleXSips = async () => {
    try {
      setLoading(true)

      const sipSum =
        sipPlans
          ?.filter(
            (plan) =>
              plan.sipStatus === 'PENDING' &&
              plan.sipInvestmentAmount &&
              plan.sipInvestmentBreakdown?.length,
          )
          ?.reduce((acc, plan) => acc + plan.sipInvestmentAmount, 0) || 0

      const payload = {
        clientCode: clientCode?.toUpperCase(),
        amount: sipSum.toString(),
        sipStartDate: sipDate,
        mandateType: 'UNIVERSAL',
      }

      const response = await post(
        'mutualfundservice/api/bseStar/mfUpload/mandateRegistration',
        payload,
      )

      setLoading(false)

      if (response?.isError) {
        showError('', getDynamicErrorMessage(response?.response?.data), () => { })

        return
      }

      const getCurrentBasketVersion = (universalBasketId) => {
        if (baskets?.state !== 'hasValue') return undefined
        return baskets?.contents?.data?.find(
          (basket) => basket.universalBasketId === universalBasketId,
        )?.versionNumber
      }

      const sips = sipPlans
        ?.filter(
          (plan) =>
            plan.sipStatus === 'PENDING' &&
            plan.sipInvestmentAmount &&
            plan.sipInvestmentBreakdown?.length,
        )
        .map((plan) => {
          const currentBasketVersion = getCurrentBasketVersion(plan?.universalBasketId)

          if (plan?.isSubsequentOneTimeOrder) {
            return {
              sipData: plan?.sipInvestmentBreakdown
                ?.filter((p) => p.weightage > 0)
                ?.map((item) => ({
                  isin: baskets?.contents?.data?.find(
                    (basket) => basket.bseSchemeCode === item.bseSchemeCode,
                  )?.isin,
                  schemeCode: item.bseSchemeCode,
                  installmentAmount: calculateParcentageAmount(
                    item.weightage,
                    plan.sipInvestmentAmount,
                  ),
                })),
              clientCode: clientCode?.toUpperCase(),
              startDate: sipDate,
              mandateId: response?.mandateId,
              customerBasketInvestmentId: plan.customerBasketInvestmentId,
              isSubsequentOneTimeOrder: plan?.isSubsequentOneTimeOrder,
              subsequentOrderId: plan?.id,
              phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
              currentBasketVersion,
            }
          } else {
            return {
              sipData: plan?.sipInvestmentBreakdown
                ?.filter((p) => p.weightage > 0)
                ?.map((item) => ({
                  isin: baskets?.contents?.data?.find(
                    (basket) => basket.bseSchemeCode === item.bseSchemeCode,
                  )?.isin,
                  schemeCode: item.bseSchemeCode,
                  installmentAmount: calculateParcentageAmount(
                    item.weightage,
                    plan.sipInvestmentAmount,
                  ),
                })),
              clientCode: clientCode?.toUpperCase(),
              startDate: sipDate,
              mandateId: response?.mandateId,
              customerBasketInvestmentId: plan.customerBasketInvestmentId,
              phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
              currentBasketVersion,
            }
          }
        })

      if (
        (response?.mandateStatus === 'NEW' || response?.mandateStatus === null) &&
        response?.status === 'SUCCESS'
      ) {
        sessionStorage.setItem(
          'userSIPs',
          JSON.stringify({
            sip: sips,
          }),
        )

        navigate('/dashboard/mutual-funds/mandate', {
          state: {
            mandateId: response?.mandateId,
            clientCode: clientCode?.toUpperCase(),
            sipDate: sipDate,
            isIndividual: false,
            isBasketOrder: false,
            isActionPlan: true,
          },
        })
      }

      if (
        response?.status === 'SUCCESS' &&
        response?.mandateStatus !== 'NEW' &&
        response?.mandateStatus !== null &&
        response?.alreadyExists
      ) {
        const handleSipRegistration = sips?.length && (await handleXSipRegistration(sips))

        if (sips.length && handleSipRegistration.status === 'SUCCESS') {
          // handleSIPUpdate()
          onOpen('openActionPlanPopup', {
            severity: 'sipsuccess',
            title: '',
            message: oneTimePlans?.length
              ? 'Your SIP has been registered successfully. Please continue to complete your one-time investment.'
              : 'Your SIP order has been placed successfully. The transaction has been processed, and your investment will be scheduled accordingly.',
            redirectTo: oneTimePlans?.length ? '/dashboard/firstTime/actionPlanUser' : '/dashboard',
            goBack: '/dashboard',
          })

          refreshMFUserBaskets()
          refreshMFUserSubsequent()
        }
      }
    } catch (error) {
      setLoading(false)
      console.log('🚀 ~ placeSIPOrder ~ error:', error)
    }
  }

  const handleXSipRegistration = async (payload) => {
    try {
      const xSIPRegistration = await post(
        'mutualfundservice/api/illusion/multiBasketSipRegistrationOrder',
        payload,
      )

      if (xSIPRegistration?.isError) {
        showError(
          'SIPs Registration Failed',
          'We encountered an issue while registering your SIP. Please try again or contact support for assistance.',
          () => { },
        )
        return
      }

      if (xSIPRegistration?.status === 'SUCCESS') {
        return xSIPRegistration
      }
    } catch (error) {
      console.log('Error registering XSIP:', error)
    }
  }

  const getDynamicErrorMessage = (dataString) => {
    const reason = dataString?.split('|')[6] || ''

    const SupportNote = (
      <>
        <br />
        <span className='text-gray-500'>To update your details, please contact support.</span>
      </>
    )

    if (reason.includes('NOMINEE'))
      return (
        <>
          Nominee authentication is pending. Please complete nominee verification to proceed.
          {SupportNote}
        </>
      )

    if (reason.includes('ELOG'))
      return (
        <>
          E-log verification is pending. Please complete the e-log process before placing an order.
          {SupportNote}
        </>
      )

    if (reason.includes('FATCA'))
      return (
        <>
          Your FATCA declaration is pending. Please update your FATCA details to continue.
          {SupportNote}
        </>
      )

    if (reason.includes('BANK'))
      return (
        <>
          Bank verification failed. Please check your bank details and try again.
          {SupportNote}
        </>
      )

    if (reason.includes('KYC'))
      return (
        <>
          KYC verification is incomplete. Please complete your KYC to proceed.
          {SupportNote}
        </>
      )

    return <>An unknown error occurred while placing your order. Please try again later.</>
  }

  const placeOneTimeOrder = async (payload) => {
    try {
      setLoading(true)
      const payload = oneTimePlans
        ?.filter((plan) => plan.oneTimeInvestmentAmount > 0)
        ?.map((plan) => {
          if (plan?.isSubsequentOneTimeOrder) {
            return {
              orderType: 'PURCHASE',
              isSubsequentOneTimeOrder: plan?.isSubsequentOneTimeOrder,
              subsequentOrderId: plan?.id,
              clientCode: clientCode?.toUpperCase(),
              orderData: plan?.oneTimeInvestmentBreakdown?.map((fund) => ({
                schemeCode: fund.bseSchemeCode,
                orderVal: fund.investmentAmount,
                isin: baskets?.contents?.data?.find(
                  (basket) => basket.bseSchemeCode === fund.bseSchemeCode,
                )?.isin,
              })),
              customerBasketInvestmentId: plan.customerBasketInvestmentId,
              phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
            }
          } else {
            return {
              orderType: 'PURCHASE',
              orderData: plan?.oneTimeInvestmentBreakdown?.map((fund) => ({
                schemeCode: fund.bseSchemeCode,
                orderVal: fund.investmentAmount,
                isin: baskets?.contents?.data?.find(
                  (basket) => basket.bseSchemeCode === fund.bseSchemeCode,
                )?.isin,
              })),
              clientCode: clientCode?.toUpperCase(),
              customerBasketInvestmentId: plan.customerBasketInvestmentId,
              phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
            }
          }
        })


      const response = await post('mutualfundservice/api/basket/multiBasketOneTimeOrder', payload)

      setLoading(false)

      if (response?.isError) {
        showError(
          'Order Placement Failed',
          getDynamicErrorMessage(response?.response?.data),
          () => { },
        )
        return
      }

      // const orderNumberMatch = response.data.match(/ORDER NO: (\d+)/)

      // const orderNumber = orderNumberMatch ? orderNumberMatch[1] : null

      if (response.status === 'SUCCESS') {
        const failures = response.basketResponses
          .map((response) => {
            const failedOrders =
              response?.orders?.filter((order) => order.status === 'FAILURE') || []
            return failedOrders.length > 0 ? { ...response, orders: failedOrders } : null
          })
          ?.filter((response) => response !== null)

        if (failures.length) {
          showError('', getDynamicErrorMessage(response?.response?.data), () => { })
          return
        }

        // console.log(oneTimePlans)
        const basketIds = payload?.map((basket) => basket.customerBasketInvestmentId)

        const orders =
          response?.basketResponses?.length > 0
            ? response?.basketResponses?.flatMap((basket) => basket?.orders || [])
            : []

        sessionStorage.setItem('oneTimeActionPlanOrders', JSON.stringify(orders))

        const lumpsumAmount = oneTimePlans?.reduce(
          (sum, investment) => sum + (investment.oneTimeInvestmentAmount || 0),
          0,
        )

        const paymentPayload = {
          clientCode: clientCode?.toUpperCase(),
          orders: orders,
          lumpsumAmount: lumpsumAmount,
          basketIds: basketIds,
        }

        navigate('/dashboard/actionplan/one-time-payment', {
          state: {
            paymentPayload,
            orderPayload: payload,
          },
        })
      } else {
        showError('Try again later.', getDynamicErrorMessage(response?.response?.data), () => { })
      }
    } catch (error) {
      console.log('🚀 ~ placeOneTimeOrder ~ error:', error)
    }
  }

  const mandateRegistration = async (mandates) => {
    setMandateLoading(true)

    try {
      const response = await post('mutualfundservice/api/bseStar/mfUpload/mandateRegistration', {
        clientCode: clientCode?.toUpperCase(),
        amount: mandateResult?.amount,
        sipStartDate: formatDate(mandateResult?.createdTimeStamp),
        mandateType: 'UNIVERSAL',
        bankaccount: selectedBank,
        ifsc: bankAccountsList?.find((bank) => bank.accountNo === selectedBank)?.ifscCode,
      })

      if (response?.isError) {
        setMandateLoading(false)
        onOpen('openMandatePopup', {
          title: <>Please try again</>,
          message: <>Your mandate setup could not be completed.</>,
          severity: 'info',
          closeButton: true,
          redirectBackTo: '/dashboard/firstTime/actionPlanUser',
          forwardTo: '/dashboard/firstTime/actionPlanUser',
          showExploreButton: true,
          exploreButtonText: 'Try Again',
        })
        return setMandateLoading(false)
      }

      if (response?.status === 'SUCCESS') {
        setMandateLoading(false)
        navigate('/dashboard/mutual-funds/mandate', {
          state: {
            mandateId: response?.mandateId,
            clientCode: clientCode?.toUpperCase(),
            sipDate: formatDate(mandateResult?.createdTimeStamp),
            isIndividual: false,
            isBasketOrder: false,
            isActionPlan: true,
            isStandaloneMandate: true,
          },
        })
      }
    } catch (error) {
      onOpen('openMandatePopup', {
        title: <>Please try again</>,
        message: <>Your mandate setup could not be completed.</>,
        severity: 'info',
        closeButton: true,
        redirectBackTo: '/dashboard/firstTime/actionPlanUser',
        forwardTo: '/dashboard/firstTime/actionPlanUser',
        showExploreButton: true,
        exploreButtonText: 'Try Again',
      })
      return setMandateLoading(false)
    }
  }

  const disableButtons = selectedPlans?.filter(
    (p) => p.sipStatus === 'PENDING' || p.orderStatus === 'ACTIVE' || p.oneTimeStatus === 'PENDING',
  )?.length

  const hasPendingPlans = adminPlans?.length > 0
  const hasMandateRequest = Boolean(mandateResult && Object.keys(mandateResult).length > 0)

  const planTabProps = {
    adminPlans,
    isAllSelected,
    setIsAllSelected,
    selectedPlans,
    openPlans,
    handleCheckboxChange,
    togglePlan,
    onOpen,
    isDesktop,
    flowStep,
    sipDate,
    sipDates,
    selectedDay,
    setSelectedDay,
    mandatesState,
    mandates,
    disableButtons,
    mandateRegistration,
    generateOTP,
    loading,
    setMessageModalState,
    openOTPPopup,
    setOpenOTPPopup,
    userDetails,
    email,
    handleSipOrOT,
  }

  return (
    <div className='fabits-page fabits-action-plan-page min-h-screen pb-40 pt-3'>
      <Tabs
        defaultValue={activeTab}
        className='mx-auto max-w-[1128px]'
        onValueChange={setActiveTab}
      >
        <div className='sticky top-0 z-10 bg-[rgba(246,246,249,0.92)] px-4 pb-2 pt-1 backdrop-blur md:px-0 dark:bg-[rgba(4,3,19,0.92)]'>
          <TabsList className='fabits-action-center-tabs mx-auto grid h-11 w-full max-w-[520px] grid-cols-3 rounded-[999px] md:h-12'>
            <TabsTrigger
              value='Investments'
              className='relative h-9 px-1 text-[11px] leading-4 sm:text-xs md:h-10 md:px-4 md:text-sm md:leading-5'
            >
              <span className='fabits-action-center-tab-label'>
                Plans
                {hasPendingPlans && (
                  <span className='fabits-action-center-tab-dot' aria-hidden='true' />
                )}
              </span>
            </TabsTrigger>

            <TabsTrigger
              value='Mandates'
              className='relative h-9 px-1 text-[11px] leading-4 sm:text-xs md:h-10 md:px-4 md:text-sm md:leading-5'
            >
              <span className='fabits-action-center-tab-label'>
                Mandates
                {hasMandateRequest && (
                  <span className='fabits-action-center-tab-dot' aria-hidden='true' />
                )}
              </span>
            </TabsTrigger>

            <TabsTrigger
              value='rebalancing'
              className='relative h-9 px-1 text-[11px] leading-4 sm:text-xs md:h-10 md:px-4 md:text-sm md:leading-5'
            >
              <span className='flex items-center justify-center gap-1.5'>Rebalancing</span>
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value='Mandates'>
          <Mandates
            mandateResult={mandateResult}
            mandateRegistration={mandateRegistration}
            mandateLoading={mandateLoading}
            mandates={mandates}
            bankAccountsList={bankAccountsList}
            selectedBank={selectedBank}
            setSelectedBank={setSelectedBank}
          />
        </TabsContent>

        <TabsContent value='Investments'>
          <Plans {...planTabProps} totalLumpsum={totalLumpsum} totalSip={totalSip} />
        </TabsContent>

        <TabsContent value='rebalancing'>
          <Rebalancing
            {...planTabProps}
            totalSip={totalSip}
            investedPlans={investedPlans}
            clientCode={clientCode}
            userDetails={userDetails}
          />
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default UserActionPlan
